import { useLocation } from 'react-router-dom'

export const useCurrentPage = () => {
  const loc = useLocation()
  return loc.pathname
}
